<template>
  <div id="app" class="uik--mtd">
    <Navigation v-if="!$route.path.startsWith('/login') && $root.isAuthenticated"/>
    <transition :name="transitionName" mode="out-in">
      <router-view v-if="!$root.isAuthenticated || showApp" :key="$route.path"/>
    </transition>
    <AppBoot
      v-if="$root.isAuthenticated"
      @ready="showApp = true"
    />
    <Loading/>
  </div>
</template>

<script>
import Navigation from "@/views/components/Navigation"
import Loading from "@/views/components/Loading"
import AppBoot from "@/components/AppBoot"

export default {
  components: {
    Navigation, Loading, AppBoot
  },
  data () {
    return {
      transitionName: "",
      showApp: false
    }
  },
  watch: {
    "$route" (to, from) {
      // Add fade transition routes to this array
      if ([
        "login",
        "settings",
        "styleguide"
      ].includes(this.$route.name)) {
        this.transitionName = "route-fade"
        return
      }
      // Experimental: if first url part is not present in new route's url default to fade
      if (!to.path.split("/").includes(from.path.split("/")[1])) {
        this.transitionName = "route-fade"
        return
      }
      const toDepth = to.path.split("/").length
      const fromDepth = from.path.split("/").length
      if (toDepth < fromDepth) {
        this.transitionName = "slide-right"
      } else if (toDepth > fromDepth) {
        this.transitionName = "slide-left"
      } else {
        this.transitionName = "route-fade"
      }
    }
  },
  created () {
    // TODO: Remove this after a while. It is only used to clean up service
    // workers for users who have them installed from legacy versions.
    if (navigator.serviceWorker) {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister()
        }
      })
    }
  }
}
</script>

<style lang="scss">
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.updateAvailable {
  width: 300px;
  position: fixed;
  top: 10px;
  left: 50%;
  margin-left: -150px;
}
@import './scss/index.scss';
</style>
